module.exports = __webpack_public_path__ + "static/media/headphone.71e02f0a.svg";